'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationPrint', ['$scope', 'Complaints', '$stateParams', 'Resource', '$sce', 'Upload', 'Permissions', '$uibModalInstance',
        function ($scope, Complaints, $stateParams, Resource, $sce, Upload, Permissions, $uibModalInstance) {
            var resolvedTimezoneId = null;
            if (window.Intl && window.Intl.DateTimeFormat) {
                var resolvedOptions = window.Intl.DateTimeFormat().resolvedOptions();
                resolvedTimezoneId = resolvedOptions && resolvedOptions.timeZone ? resolvedOptions.timeZone : null;
            }

            $scope.printInvestigationModel = {
                complaintId: $stateParams.id,
                clientTimezoneId: resolvedTimezoneId,
                clientTimezoneOffsetMinutes: new Date().getTimezoneOffset()
            };

            $scope.getPermission = function (state, variable, method) {
                if (method == null) {
                    method = 'view';
                }

                Permissions[method](state).then(function (access) {
                    $scope[variable] = access;
                })
            }

            //selectAllItems() executes when the "Select All" checkbox is toggled. It will check the permission for each component and change the components based on "Select All"'s value':
            $scope.selectAllItems = function () {
                if ($scope.hasDetailPermission) {
                    $scope.printInvestigationModel.details = $scope.printInvestigationModel.selectAll;
                    $scope.printInvestigationModel.complainant = $scope.printInvestigationModel.selectAll;
                    $scope.printInvestigationModel.subjects = $scope.printInvestigationModel.selectAll;
                    $scope.printInvestigationModel.investigationDates = $scope.printInvestigationModel.selectAll;
                    $scope.printInvestigationModel.additionalDetails = $scope.printInvestigationModel.selectAll;
                }

                if ($scope.hasActivityTrackingPermission) {
                    $scope.printInvestigationModel.activityTracking = $scope.printInvestigationModel.selectAll;
                }

                if ($scope.hasMonitoringPermission) {
                    $scope.printInvestigationModel.monitoring = $scope.printInvestigationModel.selectAll;
                }

                if ($scope.hasHistoryPermission) {
                    $scope.printInvestigationModel.history = $scope.printInvestigationModel.selectAll;
                }

                if ($scope.hasCorrespondencePermission) {
                    $scope.printInvestigationModel.correspondence = $scope.printInvestigationModel.selectAll;
                    $scope.printInvestigationModel.correspondenceContents = $scope.printInvestigationModel.selectAll;
                }

                if ($scope.hasDocumentsPermission) {
                    $scope.printInvestigationModel.documents = $scope.printInvestigationModel.selectAll;
                }

                if ($scope.hasNotesPermission) {
                    $scope.printInvestigationModel.notes = $scope.printInvestigationModel.selectAll;
                }
            };

            $scope.save = function ()
            {
                $scope.loading = true;
                Complaints.printInvestigation($scope.printInvestigationModel)
                    .then(function (pdf) {
                        if (pdf != null) {
                            // handle IE
                            var browser = Resource.browser();
                            if (browser.indexOf("Edge") >= 0 || browser.indexOf("IE") >= 0) {
                                navigator.msSaveOrOpenBlob(
                                    Upload.dataUrltoBlob(pdf)
                                );
                                var doc = elem[0].querySelector(
                                    "[id='component_pdf_preview']"
                                ).contentWindow.document;
                                doc.open();
                                doc.write("Open PDF to preview.");
                                doc.close();
                            } else {
                                $scope.pdf_preview_content = $sce.trustAsResourceUrl(
                                    URL.createObjectURL(
                                        Upload.dataUrltoBlob(
                                            "data:application/pdf;base64," + pdf.toString()
                                        )
                                    )
                                );

                                var link = document.createElement("a");
                                link.href = $scope.pdf_preview_content;
                                link.download = "investigation.pdf";
                                link.click();
                                $scope.loading = false;

                                // Close the modal when loading is complete:
                                $uibModalInstance.close(true);
                            }
                        }
                    });
            }
    }])    
;